import { cx } from './cx'
import s from './Skeleton.module.css'

/**
 * A shimmering placeholder for content that's loading — the premium alternative to
 * a bare spinner (the page keeps its shape while data arrives). Use one per line/
 * block; `SkeletonText` stacks a few lines. Width/height are any CSS length.
 */
export function Skeleton({ width = '100%', height = 14, radius = 6, className }: {
  width?: number | string; height?: number | string; radius?: number | string; className?: string
}) {
  return <span className={cx(s.sk, className)} style={{ width, height, borderRadius: radius }} aria-hidden="true" />
}

/** A stack of skeleton lines (the last a little shorter) — a loading paragraph/list. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <span className={cx(s.stack, className)} data-testid="skeleton" aria-busy="true">
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} height={12} width={i === lines - 1 ? '60%' : '100%'} />
      ))}
    </span>
  )
}
